/* Scroll motion is progressive: content remains readable without JavaScript. */
(() => {
  if (window.shimanoMotionReady) return;
  window.shimanoMotionReady = true;
  const init = root => {
    if (root.dataset.motionReady) return;
    root.dataset.motionReady = 'true';
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    const scenes = [...root.querySelectorAll('.se-hero,.se-intro,.se-feature,.se-details,.se-system')];
    const reveals = [...root.querySelectorAll('.se-feature-copy,.se-detail,.se-models article,.shimano-card,.se-comparison > h2')];
    let frame = 0;
    let observer;
    const update = () => {
      frame = 0;
      if (preference.matches || !root.isConnected) return;
      const height = innerHeight;
      scenes.forEach(scene => {
        const box = scene.getBoundingClientRect();
        if (box.bottom < 0 || box.top > height) return;
        const progress = Math.max(0, Math.min(1, (height - box.top) / (height + box.height)));
        scene.style.setProperty('--se-progress', progress.toFixed(4));
        scene.style.setProperty('--se-drift', `${((progress - .5) * 48).toFixed(2)}px`);
      });
    };
    const schedule = () => { if (!frame && !preference.matches) frame = requestAnimationFrame(update); };
    const configure = () => {
      observer?.disconnect();
      root.classList.toggle('se-motion', !preference.matches);
      reveals.forEach(el => el.classList.remove('se-waiting'));
      if (!preference.matches && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.remove('se-waiting'); observer.unobserve(entry.target); }
        }), {threshold: .08});
        reveals.forEach(el => { if (el.getBoundingClientRect().top > innerHeight) el.classList.add('se-waiting'); observer.observe(el); });
      }
      schedule();
    };
    addEventListener('scroll', schedule, {passive:true,signal:abort.signal});
    addEventListener('resize', schedule, {passive:true,signal:abort.signal});
    preference.addEventListener('change', configure, {signal:abort.signal});
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { abort.abort(); observer?.disconnect(); cancelAnimationFrame(frame); }
    }, {signal:abort.signal});
    configure();
  };
  const scan = () => document.querySelectorAll('.shimano-editorial').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
